<template>
    <div class="global-single-box">
        <div class="global-single-switch">
            <a-radio-group v-model="value" button-style="solid">
                <a-radio-button :value="$t('edit.settings.setsTitle')">
                    {{$t('edit.settings.setsTitle')}}
                </a-radio-button>
                <a-radio-button :value="$t('edit.settings.singleSenceTitle')">
                    {{$t('edit.settings.singleSenceTitle')}}
                </a-radio-button>
            </a-radio-group>
        </div>
        <div class="global-single-content">
            <div class="global-content" v-if="value == $t('edit.settings.setsTitle')">
                <slot name="global"></slot>
            </div>
            <div class="single-content" v-else>
                <slot name="single"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GlobalSingle",
        data() {
            return {
                value: this.$t('edit.settings.setsTitle')
            };
        },
    }
</script>

<style lang="less" scoped>
    .global-single-box{
        height: calc(100% - 44px);
        padding: 15px 0 15px 15px;
        overflow: hidden;
    }
    .global-single-switch{
        display: flex;
        margin-bottom: 15px;
        /deep/ .ant-radio-group{
            font-size: 12px;
        }
    }
    .global-single-content{
        padding-right:15px;
        height: calc(100% - 32px);
        overflow-y: auto;
    }
</style>
